import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WebService } from './web/web.service';
import { SecurityService } from './security.service';
import { BillingAddress, BillingAddressInput } from '../models/billing-address.model';

@Injectable({ providedIn: 'root' })
export class BillingAddressService {

  constructor(
    private webService: WebService,
    private securityService: SecurityService
  ) {}

  list(customerId: number | string): Observable<BillingAddress[]> {
    return this.webService.get(this.billingAddressesUrl(customerId))
      .pipe(map(res => (res?.result ?? []) as BillingAddress[]));
  }

  create(customerId: number | string, input: BillingAddressInput): Observable<BillingAddress> {
    const body: BillingAddressInput = { ...input, country: input.country.toUpperCase() };
    return this.webService.postPreservingHttpError(body, this.billingAddressesUrl(customerId))
      .pipe(map(res => (res?.result ?? res) as BillingAddress));
  }

  setCardBillingAddress(cardId: number, addressId: number): Observable<any> {
    return this.webService.putPreservingHttpError(
      { addressId },
      `${this.webService.HOST}/creditcard/${encodeURIComponent(String(cardId))}/billing-address`
    );
  }

  private billingAddressesUrl(customerId: number | string): string {
    const partner = encodeURIComponent(String(this.securityService.getTokenPartner()));
    const customer = encodeURIComponent(String(customerId));
    return `${this.webService.HOST}/partner/${partner}/customer/${customer}/billing-addresses`;
  }
}
